<template>
    <div class="center-department-form-box">
        <el-form 
            inline 
            :model="form" 
            :rules="rules"
            ref="rule1"
            label-width="150px"
            size="mini"
            class="center-department-form">
            <!-- 所属分行/子公司 -->
            <el-form-item 
                :label="$t('message.cdepartment.form1')"
                prop="branch_id">
                <el-select
                    v-model="form.branch_id"
                    @change="getBranchBalance">
                    <el-option
                        v-for="(item, index) in parent_company"
                        :key="index"
                        :label="item.branchname"
                        :value="item.branch_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- 部门编号 -->
            <el-form-item 
                :label="$t('message.cdepartment.form2')"
                prop="department_code">
                <el-input
                    v-model="form.department_code"
                    class="center-department-form-input"
                    clearable>
                </el-input>
            </el-form-item>
        </el-form>
        <el-form 
            inline 
            :model="form" 
            :rules="rules"
            ref="rule2"
            label-width="150px"
            size="mini"
            class="center-department-form">
            <!-- 部门名称（中） -->
            <el-form-item 
                :label="$t('message.cdepartment.form3')"
                prop="cn_name">
                <el-input
                    v-model="form.cn_name"
                    class="center-department-form-input"
                    clearable>
                </el-input>
            </el-form-item>
            <!-- 部门名称（英） -->
            <el-form-item 
                :label="$t('message.cdepartment.form4')"
                prop="en_name">
                <el-input
                    v-model="form.en_name"
                    class="center-department-form-input"
                    clearable>
                </el-input>
            </el-form-item>
        </el-form>
        <el-form 
            inline 
            :model="form" 
            :rules="rules"
            ref="rule3"
            label-width="150px"
            size="mini"
            class="center-department-form">
            <!-- 电子邮箱 -->
            <el-form-item 
                :label="$t('message.cdepartment.form5')"
                prop="email">
                <el-popover
                    placement="right-start"
                    trigger="focus">
                    <ul class="center-department-email-tips">
                        <li>{{$t("public.emailTips")}}</li>
                    </ul>
                    <el-input 
                        type="textarea"
                        v-model="form.email"
                        slot="reference"
                        autosize
                        class="center-department-form-input">
                    </el-input>
                </el-popover>
            </el-form-item>
            <!-- 联系人 -->
            <el-form-item 
                :label="$t('message.cdepartment.form6')"
                prop="principal">
                <el-input
                    v-model="form.principal"
                    class="center-department-form-input"
                    clearable>
                </el-input>
            </el-form-item>
        </el-form>
        <el-form 
            inline 
            :model="form" 
            :rules="rules"
            ref="rule4"
            label-width="150px"
            size="mini"
            class="center-department-form">
            <!-- 电话 -->
            <el-form-item 
                :label="$t('message.cdepartment.form7')"
                prop="phone">
                <el-input
                    v-model="form.phone"
                    class="center-department-form-input"
                    clearable>
                </el-input>
            </el-form-item>
            <!-- 分配金额 -->
            <el-form-item 
                :label="$t('message.cbranch.form10')">
                <el-input
                    v-model="amount2"
                    type="number"
                    min="0"
                    class="center-department-form-input"
                    clearable>
                </el-input>
                <!-- <span class="center-department-form-remarks" v-if="balance!==''">{{$t("public.remarks",{balance})}}</span> -->
				<span class="center-department-form-remarks" v-if="balance2">剩餘可分配額度：{{balance2}}</span>
            </el-form-item>
        </el-form>
        <!-- 提交按钮插槽 -->
        <el-form label-width="155px" size="mini">
            <el-form-item>
                <slot name="submit"
                    :form="form"
                    :rule="$refs">
                </slot>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { email } from "@/utils/validate";

export default {
    data() {
        let validateEmail = (rule, value, callback) => {
            email(this, false, value, callback);
        }
        return {
			amount:0,
			balance2:0,//实时计算金额
			amount2:0,//分配额度
            form: {
                branch_id: "",
                department_code: "",
                cn_name: "",
                en_name: "",
                email: "",
                principal: "",
                phone: "",
                amount: ""
            },
            rules: {
                branch_id: [
                    { required: true, message: this.$t("message.cdepartment.rule1"), trigger: 'blur' }
                ],
                department_code: [
                    { required: true, message: this.$t("message.cdepartment.rule2"), trigger: 'blur' }
                ],
                cn_name: [
                    { required: true, message: this.$t("message.cdepartment.rule3"), trigger: 'blur' }
                ],
                en_name: [
                    { required: true, message: this.$t("message.cdepartment.rule4"), trigger: 'blur' }
                ],
                email: [
                    { required: false, validator: validateEmail, trigger: 'blur' }
                ],
                principal: [
                    { required: true, message: this.$t("message.cdepartment.rule6"), trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: this.$t("message.cdepartment.rule7"), trigger: 'blur' }
                ],
            }
        }
    },
    props: {
        departmentDetail: {
            type: Object,
            default: () => { return {} }
        }
    },
    computed: mapState({
        parent_company: state => state.user.parent_company,
        balance: state => state.call.balance,
		department_detail: state => state.user.department_detail,
		
    }),
    watch: {
		balance(){
			this.balance2 = this.balance;
		},
		department_detail(){
			this.amount = this.department_detail.amount;
			this.amount2 = this.department_detail.amount;
		},
		//金额实时计算
		amount2(){
			this.CalculationAmount();
		},
        departmentDetail: {
            handler: function(value) {
                let {
                    branch_id = '',
                    department_code = '',
                    departmentname: cn_name = '',
                    en_departmentname: en_name = '',
                    email = '',
                    principal = '',
                    phone = '',
                    amount = ''
                } = value;
                this.form = {
                    branch_id,
                    department_code,
                    cn_name,
                    en_name,
                    email,
                    principal,
                    phone,
                    amount
                }
            },
            immediate: true
        }
    },
	mounted() {
		this.amount = this.department_detail.amount;
		this.amount2 = this.department_detail.amount;
	},
    methods: {
		//金额实时计算
		CalculationAmount(){
			let a = Number(this.amount) || 0;
			let data = a + Number(this.balance);
			this.balance2 =  Number(data) - Number(this.amount2);
			this.form.amount = this.amount2;
		},
        ...mapActions([
            "getBranchBalance"
        ])
    }
}
</script>

<style scoped>
.center-department-form>div{
    margin-left: 20px;
}
.center-department-form-input{
    width: 178px;
}
.center-department-form-remarks{
    margin-left: 10px;
    color: #909399;
}
.center-department-email-tips{
    list-style-type: circle;
    padding-left: 20px;
    color: #909399;
}
</style>
